import { useState } from "react";
import { useSelector } from "react-redux";
import { Card, Divider, Typography, Spin, Progress } from "antd";
import { Image } from "antd";
import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../../../components/icons/ApplicationColor";

import Dragger from "antd/es/upload/Dragger";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import {
  modifyFileName,
  uploadFileCourse,
} from "../../CAAdminCoursePages/courseUtils";

const { Title, Text } = Typography;

const CustomerRightAdd = ({ formData, setUploadedFiles }) => {
  console.log(formData, "formData in right bar");
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );

  const { name, client_id, org_type } = formData || {};

  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadPercent, setUploadPercent] = useState(50);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleClear = () => {
    setPreviewUrl(null);
    setFileList([]);
  };

  const handleUpload = async (file) => {
    setUploading(true);
    setUploadPercent(20); // Start at 20%
    try {
      // Simulate progress increments
      setTimeout(() => setUploadPercent(25), 300);
      setTimeout(() => setUploadPercent(40), 450);
      setTimeout(() => setUploadPercent(65), 600);
      setTimeout(() => setUploadPercent(90), 900);
      // Actual upload
      const file_name = await uploadFileCourse(file, "course", csrfToken);
      setUploadedFiles(file_name);
      setUploadPercent(100);
    } catch (err) {
      console.log(err);
      setUploadPercent(0);
    } finally {
      setUploading(false);
    }
  };

  const handleChange = async (info) => {
    const file = info.file.originFileObj || info.file;
    const imageUrl = URL.createObjectURL(file);

    setPreviewUrl(imageUrl);
    setFileList([
      {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: imageUrl,
        originFileObj: file,
      },
    ]);

    await handleUpload(file);
  };

  return (
    <Card
      bordered
      hoverable
      style={{
        width: "100%",
        padding: "12.5px",
        paddingTop: "5px",
        height: "100%",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        background: "#F9FBFC",
      }}
    >
      <Spin spinning={false}>
        <Title level={5} style={{ marginBottom: 16, textAlign: "center" }}>
          {classification
            ? `${capitalizeWords(classification)} Details`
            : "Customer Details"}
        </Title>
        <Divider />
        <div style={{ width: "100%", textAlign: "center", marginTop: "30px" }}>
          <Dragger
            name="file"
            multiple={false}
            customRequest={({ file }) => {}}
            maxCount={1}
            beforeUpload={() => false}
            showUploadList={false}
            accept="image/*"
            onChange={handleChange}
            fileList={fileList}
            className="custom-dragger"
            openFileDialogOnClick={!previewUrl}
            style={{
              minHeight: 180, // Increase height
              minWidth: 180, // Optional: Increase width
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              marginTop: "60px",
            }}
          >
            {previewUrl ? (
              <div style={{ textAlign: "center" }}>
                <Image
                  src={previewUrl}
                  alt="Uploaded"
                  preview={true}
                  style={{
                    maxHeight: "100px",
                    maxWidth: "100%",
                    objectFit: "contain",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
                <div
                  style={{
                    fontSize: "13px",
                    color: "#595959",
                    marginTop: "7.5px",
                  }}
                >
                  {(() => {
                    const name = fileList[0]?.name;
                    if (!name) return "";

                    const modifiedName = modifyFileName(name); // remove timestamp
                    const dotIndex = modifiedName.lastIndexOf(".");
                    const ext = modifiedName.substring(dotIndex);
                    const base = modifiedName.substring(0, dotIndex);

                    return base.length > 15
                      ? base.substring(0, 15) + "..." + ext
                      : modifiedName;
                  })()}
                  <DeleteOutlined
                    onClick={handleClear}
                    style={{ marginLeft: "5px" }}
                  />
                </div>
                {uploading && (
                  <Progress
                    percent={uploadPercent}
                    size="small"
                    status={uploadPercent === 100 ? "success" : "active"}
                    style={{ marginTop: 10 }}
                  />
                )}
              </div>
            ) : (
              <>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ fontSize: "25px" }} />
                </p>
                <p
                  style={{ fontSize: "13px", color: "gray", padding: "0 10px" }}
                >
                  Click or drag image to upload
                </p>
              </>
            )}
          </Dragger>
        </div>

        <div
          style={{
            width: "100%",
            textAlign: "left",
            gap: "12.5px",
            display: "flex",
            flexDirection: "column",
            marginInlineStart: "5px",
            marginTop: "90px",
          }}
        >
          <div>
            <Text style={{ color: "gray" }}>Name : </Text>
            <Text>{name}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>
              {classification ? capitalizeWords(classification) : "Customer"} ID
              :{" "}
            </Text>
            <Text>{client_id}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>Type : </Text>
            <Text>{org_type}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>Created At : </Text>
            <Text>{formatDateWithSuffix(new Date())}</Text>
          </div>
        </div>

        <Divider />
      </Spin>
    </Card>
  );
};

export default CustomerRightAdd;
